import React, { Component } from 'react'
import Link from 'gatsby-link'
import { push } from 'gatsby-link'
import styled from 'styled-components'
import posed from 'react-pose'

const Tile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 25vw;
  height: 25vw;
  background: ${props => `url(${props.image})  no-repeat center center`};
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  point-events: none;
  // border-right: 0.7vw solid white;
  // border-bottom: 0.7vw solid white;
`
const TileDimmer = styled.div`
  left: 0;
  top: 0;
  width: 25vw;
  height: 25vw;
  background-color: rgba(1, 0, 0, 0.15);
  border-right: 0.7vw solid white;
  border-bottom: 0.7vw solid white;
`
const Info = posed.div({
  idle: { opacity: 0 },
  hovering: { opacity: 1 },
})

const InfoStyled = styled(Info)`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 25vw;
  height: 25vw;
  background-color: rgba(0, 0, 0, 0.6);
  border-right: 0.7vw solid white;
  border-bottom: 0.7vw solid white;
  color: white;
`
const Title = styled.span`
  font-family: OpensansBold;
  font-size: 0.9vw;
  line-height: 1.2;
  width: 70%;
  text-transform: uppercase;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
`
// const Subtitle = styled.span`
//   font-family: OpensansItalic;
//   text-transform: uppercase;
//   font-size: 0.7vw;
// `

class Mosaic extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hovering: false,
    }
  }

  render() {
    const { title, subtitle, image } = this.props
    return (
      <Tile image={image.url}>
        <InfoStyled
          pose={this.state.hovering ? 'hovering' : 'idle'}
          onMouseEnter={() => this.setState({ hovering: true })}
          onMouseLeave={() => this.setState({ hovering: false })}
          onClick={() => push(this.props.url)}
        >
          <Title>{title}</Title>
          {/* <Subtitle>{subtitle}</Subtitle> */}
        </InfoStyled>
        <TileDimmer />
      </Tile>
    )
  }
}

export default Mosaic



// WEBPACK FOOTER //
// ./src/components/mosaic-tile.js